export enum OrdersType {
  PROPIO = 'propio',
  GOOGLE = 'google',
}
